import { Spinner } from "@material-tailwind/react";

function DefaultLoading({className}:{className?: string}) {
  return <Spinner className={`fill-primary h-10 w-10 mx-auto ${className}`} />;
}

export default DefaultLoading;
